import { useSelector } from "react-redux";
import { CartItem } from "./singleCartItem";

export function AddToCart() {
  const { cartList } = useSelector((state) => state.productsNCart);

  // total item
  let totalItem =
    cartList?.length > 0
      ? cartList?.reduce((total, value) => total + value?.quantity, 0)
      : 0;
  return (
    <>
      <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        {cartList.length > 0 &&
          cartList.map((item, index) => <CartItem key={index} item={item} />)}
        <div className="flex justify-center items-center text-center">
          <div className="text-xl font-semibold">
            <p>Total Item</p>
            <p className="text-5xl">{totalItem}</p>
          </div>
        </div>
      </div>
    </>
  );
}
